import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Broker, Platform } from '@c4/core';
import { AuthenticationService } from '@c4/auth';
import { Observable } from 'rxjs';
import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ConnectedDeviceService, NetworkService, VersionsService, EnvironemntService } from '../services';
import { UIModule } from '@c4/ui';

interface Option {
  name: string;
  value: string
}

@Component({
  selector: 'sysman-vpn-config',
  templateUrl: './sysman-vpn-config.component.html',
  styleUrls: ['./sysman-vpn-config.component.less']
})
export class SysmanVpnConfigComponent extends SysmanComponentBase implements OnInit, IOnBrokerConnectedInit {

  initialSelectedVPNHost: Option;
  selectedVPNHost: Option;

  private hosts: Option[] = [
    { name: 'Production', value: 'prod' },
    { name: 'Beta', value: 'beta' }
  ]

  private showBrokerHostWaitModal = false;
  private showRebootModal = false;

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute,
    private broker: Broker, private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService,
    private networkService: NetworkService,
    private environemntService: EnvironemntService,
    private versionsService: VersionsService, 
    private auth: AuthenticationService) {

    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init

    this.selectedVPNHost = this.hosts.find(h => h.value == 'prod');
    this.initialSelectedVPNHost = this.hosts.find(h => h.value == 'prod');
  }

  ngOnInit() {
    super.OnInit();
  }

  onBrokerConnectedInit() {
    this.init();

    this.subscriptions.push(
      this.broker.connected.skip(1).subscribe(
        (data: any) => {
          console.log("Rebooting after env change - CONNECTED");
          this.showBrokerHostWaitModal = false;
          this.init();
        },
        (err: any) => console.error('vpn: broker event for connected error', err))
    );

    this.subscriptions.push(
      this.broker.disconnected.skip(1).subscribe(
        (data: any) => {
          console.log("Rebooting after env change - DISCONNECTED");
        },
        (err: any) => console.error('vpn: broker event for disconnected error', err))
    );
  }

  init() {
    this.connectedDeviceService.setWorking(true);

    this.connDevice.take(1).subscribe(conn => {
      this.environemntService.getEnvironment().then(
        (data: { environment: string }) => {
          this.connectedDeviceService.setWorking(false);
          console.log('in getEnv()', data);
          this.selectedVPNHost = this.hosts.find(h => h.value == data.environment);
          this.initialSelectedVPNHost = this.selectedVPNHost;
        },
        (err: any) => {
          this.connectedDeviceService.setWorking(false);
          console.error('getEnv() error: ', err);
        });
    });
  }

  ngOnDestroy() {
    super.destroy();
  }

  onClickSetVPNHost() {
    this.showRebootModal = true;
  }

  setVPNHost() {
    console.debug('SysmanVpnConfigComponent: setVPNHost()', this.selectedVPNHost);

    this.connectedDeviceService.setWorking(true);
    this.connDevice.take(1).subscribe(conn => {
      this.environemntService.setEnvironment(this.selectedVPNHost.value).then(
        (result: any) => {
          console.log('in setVPNHost()', result);
          this.connectedDeviceService.setWorking(false);
          this.showBrokerHostWaitModal = true;
          // display modal for 5 seconds then go back to dashboard
          setTimeout(o => {
              this.router.navigate(['/']);
          }, 5000);
          // force reboot on VPN change
          this.networkService.rebootDevice().then(
            (data: any) => {
              console.log('in setVPNHost() reboot()', data);
            },
            (err: any) => {
              console.error('in setVPNHost() reboot() error: ', err);
            });
        },
        (err: any) => {
          console.error('setVPNHost() error: ', err);
          this.connectedDeviceService.setWorking(false);
        });
    });
  }

  hostSelected(val: string) {
    this.selectedVPNHost = this.hosts.find(h => h.value == val);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-vpn-config/sysman-vpn-config.component.ts